<template>
    <div class="a-modal">
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ $lang('statisticModal.title') }}</span>
        </div>
        <div class="popup__content popup__content--pt-small popup__content--pb-big">
            <form class="form" ref="form">
                <div class="a-filters__item">
                    <span id="end" class="form__label">{{ $lang('statisticModal.period') }}</span>
                    <date-interval id="start" slot="reference" v-model="filters" :errors-notifier="errors"/>
                </div>
                <span class="form__label">{{ $lang('statisticModal.label3') }}</span>
                <el-select filterable
                           slot="reference"
                           class="input"
                           :loading-text="$lang('el-select.loading')"
                           :noDataText="$lang('el-select.noDataText')"
                           :noMatchText="$lang('el-select.noMatchText')"
                           v-model="filters.mastersId"
                           multiple
                           collapse-tags
                           required>
                    <el-option key="all" value="all" :label="$lang('statisticModal.label3.selectLabel')" v-show="masters.length > 0"></el-option>
                    <el-option v-for="item in masters"
                               :key="item.id"
                               :value="item.id"
                               :label="item.user.name">
                    </el-option>
                </el-select>
            </form>
        </div>
        <div class="popup__footer">
            <div v-if="$route.params.id">
                <button class="btn btn--middle btn--main-bg"
                        style="margin-right: 10px; margin-bottom: 10px;"
                        :disabled="partnerId === null"
                        @click.prevent="send()">{{ $lang('statisticModal.button') }}
                </button>
                <button class="btn btn--middle btn--main-bg"
                        style="margin-bottom: 10px;"
                        :disabled="partnerId === null"
                        @click.prevent="sendPartner()">{{ $lang('statisticModal.button2') }}
                </button>
            </div>

            <div v-else>
                <button class="btn btn--middle btn--main-bg"
                        style="margin-right: 10px; margin-bottom: 10px;"
                        :disabled="partnerId === null"
                        @click.prevent="save()">{{ $lang('statisticModal.button.save') }}
                </button>
                <button class="btn btn--middle btn--main-bg"
                        style="margin-bottom: 10px;"
                        :disabled="partnerId === null"
                        @click.prevent="sendPartner()">{{ $lang('statisticModal.button.send') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../../api/api";
import errors from "../../../mixins/errors";
import validator from "../../../mixins/validator";
import DateInterval from "../../../components/DateInterval";
import Vue from "vue";

const _get = require('lodash/get');

export default {
    name: "StatisticModal",
    mixins: [errors, validator],
    components: {DateInterval},
    data() {
        return {
            filters: {
                start: '',
                end: '',
                mastersId: ['all'],
            },
            masters: [],
            partnerId: null,
            errors: {
                start: {isError: false, message: ''},
                end:  {isError: false, message: ''},
            },
            rules: {
                start: [
                    {required: true, message: Vue.prototype.$lang('statisticModal.start')},
                ],
                end: [
                    {required: true, message: Vue.prototype.$lang('statisticModal.end')},
                ]
            }
        }
    },
    watch: {
        filters: {
            handler() {
                this.clearErrors();
            },
            deep: true
        },
        'filters.mastersId': {
            handler(mastersId, old) {
                let selected = mastersId.filter(masterId => !old.includes(masterId));

                if (selected.length > 0) {
                    if (selected[0] === 'all') {
                        this.filters.mastersId = ['all'];
                    } else {
                        this.filters.mastersId = mastersId.filter(mastersId => mastersId !== 'all');
                    }
                }
            },
            deep: true
        }
    },
    mounted() {
        this.partnerId = _get(this.$route, 'params.id', null)
                ?? _get(window.laravel, 'user.partner_data.id', null);

        if (this.partnerId === null) {
            return;
        }

        ApiService.get('/partner/' + this.partnerId + '/masters')
            .then((response) => {
                this.masters = response.data;
            }).catch((error) => {
                console.log(error);
            });
    },
    methods: {
        send() {
            this.validate(() => {
                this.$loading(this.$optionsLoading);

                ApiService.post('/partner/' + this.partnerId + '/send-statistic', {filters: this.filters})
                    .then(() => {
                        this.$appNotify.success(Vue.prototype.$lang('statisticModal.success'));
                    })
                    .catch(() => {
                        this.$appNotify.error('Ошибка');
                    })
                    .finally(() => {
                        this.$loading({}).close();
                    })
            }, {...this.filters});
        },
        save() {
            this.validate(() => {
                let params = {
                    start: this.filters.start,
                    end: this.filters.end,
                    mastersId: this.filters.mastersId,
                };

                params = new URLSearchParams(params);

                window.open(`/cabinet/download-statistics/${this.partnerId}?${params.toString()}`);
            }, {...this.filters});
        },
        sendPartner() {
            this.validate(() => {
                ApiService.post('/partner/' + this.partnerId + '/send-partner-statistic', {filters: this.filters})
                    .then(() => {
                        this.$appNotify.success(Vue.prototype.$lang('statisticModal.success2'));
                    })
                    .catch(() => {
                        this.$appNotify.error(Vue.prototype.$lang('statisticModal.error'));
                    });
            }, {...this.filters});
        }
    },
}
</script>
